<template>
  <v-container id="eixo-list">
    <v-row>
      <v-col>Eixos</v-col>
      <v-col class="text-right">
        <app-modal-insert-eixo
          :edit="false"
          :object="null"
          :color="'success'"
          :icon="'mdi-plus-circle'"
          @on-save="loadEixos"
        >
          <template v-slot:title :edit="false"> Cadastrar Eixo </template>
        </app-modal-insert-eixo>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="payload"
          class="elevation-1"
          hide-default-footer
          disable-pagination
        >
          <template v-slot:item.nome="{ item }">
            <span>
              {{ item.nome }}
            </span>
          </template>

          <template v-slot:item.acoes="{ item }">
            <v-row v-if="!item.nacional">
              <v-col cols="1">
                <app-modal-insert-eixo
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadEixos"
                >
                  <template v-slot:title> Edição de Eixo </template>
                </app-modal-insert-eixo>
              </v-col>
            </v-row>
          </template>

          <template v-slot:item.acoes_delete="{ item }">
            <v-row v-if="!item.nacional">
              <v-col cols="1">
                <app-modal-delete :object="item" @on-save="loadEixos">
                  <template v-slot:title> Deletar Eixo </template>
                </app-modal-delete>
              </v-col>

              <v-col cols="1"> </v-col>
            </v-row>
          </template>

          <template slot="no-data">
            <span> Nenhum Eixo retornado </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import AppModalInsertEixo from "./ModalInsert";
import { eixoAPI } from "../API/eixoAPI";
import { mapActions, mapGetters } from "vuex";
import AppModalDelete from "./../components/ModalDelete";

export default {
  components: {
    AppModalInsertEixo,
    AppModalDelete,
  },
  data() {
    return {
      headers: [
        { text: "Eixos", value: "nome" },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
      ],
      payload: [],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    loadEixos() {
      this.setLoading(true);
      eixoAPI
        .list()
        .then((resp) => {
          this.payload = resp.data;

          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao obter Eixos");
        });
    },
  },
  mounted() {
    this.loadEixos();
  },
};
</script>
